module.exports = __webpack_public_path__ + "static/img/developing.a752c14.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/developing.png
// module id = c1mC
// module chunks = 13